export const myProgressTypes = {
  FETCH_MY_PROGRESS_REQUEST: "[MY_PROGRESS] FETCH REQUEST",
  FETCH_MY_PROGRESS_FINISH: "[MY_PROGRESS] FETCH FINISH",
  FETCH_MY_PROGRESS_FAIL: "[MY_PROGRESS] FETCH FAIL",
};
